export const languageItems = [
    { key: 'en', lang: 'English' },
    { key: 'hn', lang: 'Hindi' },
    { key: 'pb', lang: 'Punjabi' }
];